export default "__VITE_ASSET__BHSpuiZZ__"